import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

export default function Pagination({ page, pageSize, total, onChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  const go = (p) => onChange(Math.max(1, Math.min(totalPages, p)));

  const pageNumbers = () => {
    const nums = [];
    const win = 1;
    const add = (n) => { if (!nums.includes(n)) nums.push(n); };
    add(1);
    for (let i = page - win; i <= page + win; i++) {
      if (i > 1 && i < totalPages) add(i);
    }
    if (totalPages > 1) add(totalPages);
    nums.sort((a, b) => a - b);
    const out = [];
    let prev = 0;
    for (const n of nums) {
      if (n - prev > 1) out.push('…');
      out.push(n);
      prev = n;
    }
    return out;
  };

  if (totalPages <= 1) {
    return (
      <div className="flex items-center justify-between px-4 py-3 border-t border-slate-200 dark:border-slate-700 text-sm text-slate-600 dark:text-slate-400">
        <div>{total} {total === 1 ? 'transação' : 'transações'}</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-slate-200 dark:border-slate-700 text-sm">
      <div className="text-slate-600 dark:text-slate-400">
        Exibindo <span className="font-semibold text-slate-800 dark:text-slate-200">{from}–{to}</span> de <span className="font-semibold text-slate-800 dark:text-slate-200">{total}</span>
      </div>
      <div className="flex items-center gap-1">
        <NavBtn disabled={page === 1} onClick={() => go(1)} title="Primeira"><ChevronsLeft className="w-4 h-4" /></NavBtn>
        <NavBtn disabled={page === 1} onClick={() => go(page - 1)} title="Anterior"><ChevronLeft className="w-4 h-4" /></NavBtn>
        {pageNumbers().map((n, i) => (
          n === '…' ? (
            <span key={`e${i}`} className="px-2 text-slate-400">…</span>
          ) : (
            <button key={n} onClick={() => go(n)}
              className={`min-w-[34px] px-2 py-1.5 rounded-md text-sm font-medium ${n === page ? 'bg-gradient-to-r from-indigo-600 to-blue-500 text-white' : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700'}`}>
              {n}
            </button>
          )
        ))}
        <NavBtn disabled={page === totalPages} onClick={() => go(page + 1)} title="Próxima"><ChevronRight className="w-4 h-4" /></NavBtn>
        <NavBtn disabled={page === totalPages} onClick={() => go(totalPages)} title="Última"><ChevronsRight className="w-4 h-4" /></NavBtn>
      </div>
    </div>
  );
}

function NavBtn({ children, disabled, onClick, title }) {
  return (
    <button onClick={onClick} disabled={disabled} title={title}
      className="p-1.5 rounded-md text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed">
      {children}
    </button>
  );
}
